var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvidence1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D0E1"
    },
    d: "M256,512C114.841,512,0,397.159,0,256S114.841,0,256,0s256,114.841,256,256S397.159,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51B3DA"
    },
    d: "M256,0v512c141.159,0,256-114.841,256-256S397.159,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E9F4"
    },
    d: "M256,445.677c-104.589,0-189.676-85.089-189.676-189.677S151.411,66.324,256,66.324 S445.677,151.412,445.677,256S360.589,445.677,256,445.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80D0E1"
    },
    d: "M256,66.324v379.353c104.589,0,189.677-85.089,189.677-189.677S360.589,66.324,256,66.324z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5E5B"
    },
    d: "M307.103,274.842c-32.208,0-58.41-26.203-58.41-58.41s26.202-58.41,58.41-58.41 s58.41,26.203,58.41,58.41S339.311,274.842,307.103,274.842z M307.103,195.706c-11.428,0-20.726,9.298-20.726,20.726 s9.298,20.726,20.726,20.726s20.726-9.298,20.726-20.726S318.531,195.706,307.103,195.706z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5E5B"
    },
    cx: 208.894,
    cy: 314.107,
    r: 39.568
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5E5B"
    },
    d: "M171.174,230.533l-12.565-48.989c-2.586-10.08,3.49-20.347,13.57-22.932 c10.082-2.581,20.347,3.49,22.932,13.57l12.565,48.989c2.586,10.079-3.49,20.347-13.57,22.932 C184.02,246.688,173.759,240.61,171.174,230.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF423D"
    },
    d: "M307.103,158.022c-21.967,0-41.132,12.194-51.104,30.163v56.493 c9.972,17.969,29.137,30.163,51.104,30.163c32.208,0,58.41-26.203,58.41-58.41S339.311,158.022,307.103,158.022z M307.103,237.158 c-11.428,0-20.726-9.298-20.726-20.726s9.298-20.726,20.726-20.726s20.726,9.298,20.726,20.726S318.531,237.158,307.103,237.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF423D"
    },
    d: "M335.533,348.649l-41.452-7.537c-10.237-1.86-17.029-11.669-15.167-21.908 c1.859-10.239,11.673-17.031,21.908-15.168l41.452,7.537c10.237,1.86,17.029,11.669,15.166,21.908 C355.581,343.723,345.768,350.511,335.533,348.649z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvidence1);
export default __webpack_public_path__ + "static/media/evidence1.c295db7046744266db859c429e5cc5e6.svg";
export { ForwardRef as ReactComponent };